import React from 'react';

const ViewToggle = ({ viewMode, onViewChange }) => {
  return (
    <div className="view-toggle mb-3">
      <div className="btn-group" role="group">
        <button
          type="button"
          className={`btn ${viewMode === 'grid' ? 'btn-primary' : 'btn-outline-primary'}`}
          onClick={() => onViewChange('grid')}
          title="Grid View"
          style={{
            minHeight: '40px',
            minWidth: '40px',
            borderRadius: '8px 0 0 8px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '14px',
            padding: '0.5rem',
          }}
        >
          <i className="fa fa-th"></i>
        </button>
        <button
          type="button"
          className={`btn ${viewMode === 'list' ? 'btn-primary' : 'btn-outline-primary'}`}
          onClick={() => onViewChange('list')}
          title="List View"
          style={{
            minHeight: '40px',
            minWidth: '40px',
            borderRadius: '0 8px 8px 0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '14px',
            padding: '0.5rem',
            marginLeft: '-1px', // Overlap border for seamless button group
          }}
        >
          <i className="fa fa-list"></i>
        </button>
      </div>
    </div>
  );
};

export default ViewToggle;